import { render, staticRenderFns } from "./ScrollLoad.vue?vue&type=template&id=121460e8&scoped=true"
import script from "./ScrollLoad.vue?vue&type=script&lang=js"
export * from "./ScrollLoad.vue?vue&type=script&lang=js"
import style0 from "./ScrollLoad.vue?vue&type=style&index=0&id=121460e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121460e8",
  null
  
)

export default component.exports